
import Vue from "vue";
import WJsonViewerWrapper from "./JsonViewerWrapper.vue";
import WJsonViewerKey from "./JsonViewerKey.vue";

export default Vue.extend({
	props: {
		v: {
			type: [Object as ()=>{value:boolean | string | number | Object }],
		},
		keyName: {
			type: String,
			required: true
		},
		isLastItem: Boolean,
		open: Boolean,
		hideKey: Boolean
	},
	computed: {
		value():boolean | string | number | Object {
			return this.v.value;
		},
		isBoolean():boolean {
			return typeof(this.value) == "boolean";
		},
		isNumber():boolean {
			return typeof(this.value) == "number";
		},
		isString():boolean {
			return typeof(this.value) == "string";
		},
		isDate():boolean {
			return typeof(this.value) == "object" && (this.value as any) instanceof Date;
		},
		isNull():boolean {
			return this.value === undefined || this.value === null;
		},
		printedValue():string{
			if (this.isNull){
				return "null";
			}
			if (this.isDate) {
				return `"${(this.value as any as Date).toJSON()}"`;
			}
			if (this.isString){
				return `"${this.value}"`;
			}
			return `${this.value}`;
		}
	},
	components: {
		WJsonViewerWrapper,
		WJsonViewerKey

	}
});
